import { EMPTY, empty as observableEmpty } from 'rxjs';

import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChange,
  ViewEncapsulation,
} from '@angular/core';
import { ConfirmationOrder } from '@models/confirmation-order';
import { GENERAL_CODE_CALLBACKS, TradeInfo } from '@models/trade-info.class';
import { Store } from '@ngrx/store';

import { OperationError } from '@models/operationError.class';
import { catchError } from 'rxjs/operators';
import {
  AppState,
  OPERATION_MODAL_OPENED,
  OPERATION_RESET,
  ORDER_TYPE,
  ORDER_TYPE_LIST,
  TRACKING_EVENTS,
  USER_ROLES,
  VIGENCIA,
} from 'src/app';
import {
  NEW_RELIC_KNOWN_ERRORS,
  NewRelicLogger,
} from 'src/components/shared/newrelicLogger/newRelicLogger.class';
import {
  MarketService,
  NotificationService,
  OperationService,
  PatronService,
} from 'src/core';
import {
  AnalyticsTrackingService,
  TrackingOrderType,
} from 'src/core/services/analyticsTracking.service';
import { ChangeCharacterFromIssue } from 'src/shared/utility/change-character';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ventaencorto-order',
  templateUrl: './ventaEnCorto.component.html',
  styleUrls: ['./ventaEnCorto.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VentaEnCortoOrderComponent implements OnChanges {
  issuesValidToShortSell: any[] = [];
  @Input() selectedPrice: number;
  @Input() currentContract: any;
  @Input() hasShortSellContract: any;
  @Input() currentIssue: any;
  @Input() isReadAndWrite: boolean;
  @Input() hasIssue: boolean;
  @Input() replaceTitles: number;
  @Input() isInternalUser: boolean;
  @Input() userRole: boolean;
  @Input() mfaType: number;
  @Input() readToken: string;
  @Input() elPatronData: any;
  @Input() isDiscretional: any;
  @Input() isGeolocationEnabled: boolean;
  @Input() isPositionMocked: boolean;
  public confirmationOrder: ConfirmationOrder;
  private bitBuy: boolean;
  public isIssueAllowedShortSell = false;
  public isValidissueAndContractShortSale = false;
  public titles = 0;
  private price = 0;
  public minPrice = 0;
  private order: any = {};
  private duration = 1;

  private vigencia = VIGENCIA;

  private saleType: string;
  public showConfirmation = false;
  private lockConfirmation = false;

  private montoAllow = false;

  private token: string;

  private hrefmailto: any;

  public canOperate = true;
  private lockCancel = false;

  private tradeInfo: TradeInfo;

  constructor(
    private el: ElementRef,
    private notificationService: NotificationService,
    private operationService: OperationService,
    private store: Store<AppState>,
    private marketService: MarketService,
    private patronService: PatronService,
    private analyticsTrackingService: AnalyticsTrackingService,
    private newRelicLogger: NewRelicLogger,
  ) {
    this.getAvaliableShortSellEquities();
  }

  reset() {
    this.titles = 0;
    this.price = 0;
    this.order = {};
    this.duration = 1;
    this.saleType = '';
    this.showConfirmation = false;
    this.lockConfirmation = false;
    this.token = '';
    this.replaceTitles = 0;
    this.selectedPrice = 0;

    this.store.dispatch({
      type: OPERATION_RESET,
      payload: { reset: true },
    });

    this.store.dispatch({
      type: OPERATION_MODAL_OPENED,
      payload: { isModalOpened: this.showConfirmation },
    });
  }

  changeToken(event: any) {
    if (this.montoAllow) {
      if (event.length > 6) {
        this.lockConfirmation = true;
        return false;
      } else if (event.length === 6) {
        this.lockConfirmation = false;
      } else {
        this.lockConfirmation = true;
        this.token = event;
      }
    } else {
      this.lockConfirmation = true;
      return false;
    }
  }

  setTitles(event: any) {
    this.titles = event;
    // this.isValidTitles();
    this.isOrderReady(true);
  }

  setPrice(event: any) {
    const price = Number(event);
    const decimalsToFix = price < 1 ? 3 : 2;

    this.price = Number(price.toFixed(decimalsToFix));

    this.isValidPrice();
    this.isOrderReady(true);
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    const { currentIssue, replaceTitles, userRole, selectedPrice } = changes;

    if (userRole !== undefined && userRole.currentValue !== undefined) {
      this.canOperate = !this.isInternalUser;
      this.canOperate =
        userRole.currentValue === USER_ROLES.READONLY ? false : this.canOperate;
    }

    if (selectedPrice && selectedPrice.currentValue !== undefined) {
      this.setPrice(selectedPrice.currentValue);
    }

    if (currentIssue && currentIssue.currentValue) {
      this.validIssue();
      this.isOrderReady(true);
    }

    if (replaceTitles && replaceTitles.currentValue) {
      if (changes.replaceTitles.currentValue > 0) {
        this.titles = changes.replaceTitles.currentValue;
      }
    }
  }

  isValidTitles(onlyCheck: boolean = false) {
    if (this.titles <= 0 || isNaN(this.titles)) {
      return false;
    } else {
      return true;
    }
  }

  isValidPrice(onlyCheck: boolean = false) {
    if (this.price <= 0 || isNaN(this.price)) {
      return false;
    } else {
      return true;
    }
  }

  isValidIssue() {
    if (this.currentIssue !== undefined) {
      if (this.currentIssue.issueID !== undefined) {
        return true;
      }
    }
    return false;
  }

  isOrderReady(onlyCheck: boolean = false) {
    const parent = this.el.nativeElement;
    if (!this.canOperate) {
      return;
    }

    if (
      !this.isValidTitles(onlyCheck) ||
      !this.isValidPrice(onlyCheck) ||
      !this.isValidIssue()
    ) {
      if (parent.querySelector('.btn-shortsale') !== null) {
        parent.querySelector('.btn-shortsale').classList.remove('active');
      }
      return false;
    } else {
      if (parent.querySelector('.btn-shortsale') !== null) {
        parent.querySelector('.btn-shortsale').classList.add('active');
      }
      return true;
    }
  }

  buildOrder() {
    const DURATION = this.duration;
    const CAPITAL_ORDER: number = ORDER_TYPE.VENTACORTO;

    this.order = {
      contractId: this.currentContract,
      duration: DURATION,
      orders: [
        {
          issueId: new ChangeCharacterFromIssue().ChangeToAmpersand(
            this.currentIssue.issueID,
          ),
          instrumentType: this.currentIssue.instrumentType,
          quantity: this.titles,
          price: this.price,
          capitalOrderTypeId: CAPITAL_ORDER,
        },
      ],
    };
  }

  tryShortSale() {
    if (this.isOrderReady()) {
      this.buildOrder();
      this.saleType = 'venta';
      this.bitBuy = false;
      this._getChallenge();
    } else {
      this.setShowConfirmation();
    }
  }

  setShowConfirmation(toShow: boolean = false) {
    this.showConfirmation = toShow;
    this.montoAllow = true;
    this.lockConfirmation = this.isReadAndWrite ? false : true;
    if (this.titles * this.price < 10000) {
      this.lockConfirmation = true;
      this.montoAllow = false;
    }

    if (!this.showConfirmation) {
      this.token = '';
    } else {
      this.confirmationOrder = {
        issueID: this.order.orders[0].issueId,
        issueName: this.currentIssue.issueName,
        price: this.order.orders[0].price,
        titles: this.order.orders[0].quantity,
        vigency: this.order.duration,
        type: 'Venta en Corto',
        isBuy: this.bitBuy,
        typeId: ORDER_TYPE_LIST.shortSell,
      };

      this.tradeInfo = new TradeInfo(
        false,
        this.currentIssue,
        TrackingOrderType.ShortSelling,
        window.location.pathname,
        this.titles.toString(),
        this.saleType,
        (this.price * this.titles).toString(),
        this.price.toString(),
        this.order.duration,
      );

      const startTradeInfoData = this.tradeInfo.getAnaliticsTradeInfo();

      this.analyticsTrackingService.logEvent(
        TRACKING_EVENTS.start_trade.event,
        startTradeInfoData,
      );
    }

    this.store.dispatch({
      type: OPERATION_MODAL_OPENED,
      payload: { isModalOpened: this.showConfirmation },
    });
  }

  cancelConfirmation() {
    this.showConfirmation = false;
    this.lockConfirmation = false;
    this.token = '';

    this.store.dispatch({
      type: OPERATION_MODAL_OPENED,
      payload: { isModalOpened: this.showConfirmation },
    });
  }

  registerOrder() {
    const startTime: any = new Date();
    const hash: any = this.newRelicLogger.buildHash(
      startTime.getTime(),
      this.order.contractId,
      this.currentIssue.issueID,
      this.titles,
      this.order.orders[0].capitalOrderTypeId,
    );

    this.order.orders[0].hash = hash;

    this.operationService
      .registerCapitalOrder(this.order)
      .pipe(
        catchError((error: OperationError) => {
          const customAttributes = {
            _type: 'VentaEnCorto',
            contractId: this.currentContract,
          };

          this.newRelicLogger.setEvent(
            NEW_RELIC_KNOWN_ERRORS.tradeError,
            error.toJSON(),
            customAttributes,
          );

          this.tradeInfo.setSuccess(false);
          this.tradeInfo.setCallback(error.message);
          this.tradeInfo.setContractId(this.currentContract);

          const tradeErrorInfoData = this.tradeInfo.getAnaliticsTradeInfo();
          this.tradeInfo.setContractId('');

          this.analyticsTrackingService.logEvent(
            TRACKING_EVENTS.trade.event,
            tradeErrorInfoData,
          );

          this.reset();
          return EMPTY;
        }),
      )
      .subscribe((value: any) => {
        const orderId: number =
          value.electronicOrderId !== undefined && value.electronicOrderId > 0
            ? value.electronicOrderId
            : value.vigenciaId;

        this.reset();
        this.notificationService.showSuccess({
          title: 'Orden Ejecutada',
          message: `La orden ${orderId} fue enviada correctamente.`,
          eventId: undefined,
          isBusinessError: false,
        });

        this.tradeInfo.setSuccess(true);
        this.tradeInfo.setCallback(GENERAL_CODE_CALLBACKS.SUCCESS);
        const tradeSuccesInfoData = this.tradeInfo.getAnaliticsTradeInfo();

        this.analyticsTrackingService.logEvent(
          TRACKING_EVENTS.trade.event,
          tradeSuccesInfoData,
        );
      });
  }

  doMovement() {
    if (this.lockConfirmation) {
      return;
    }
    this.lockCancel = true;
    this.lockConfirmation = true;
    if (!this.isReadAndWrite && this.token.length !== 0) {
      this.updateSession(this.token);
    } else {
      this.registerOrder();
    }
  }

  private getAvaliableShortSellEquities(): void {
    this.marketService.getAvaliableShortSellEquities().subscribe(
      (values: any) => {
        values.forEach((issue: any) => {
          const item: any = {
            symbol: issue.issue,
            minimumCommisionForWeekToShortSell: issue.comission,
            last: 0,
            instrumentType: -1,
          };
          this.issuesValidToShortSell.push(item);
        });
        this.validIssue();
      },
      () => {
        // Do nothing, just catch error
      },
    );
  }

  private validIssue() {
    if (this.currentIssue !== undefined && this.currentIssue !== '') {
      this.isIssueAllowedShortSell =
        this.issuesValidToShortSell.findIndex(
          (item) => item.symbol === this.currentIssue.issueID,
        ) >= 0;
    } else {
      this.isIssueAllowedShortSell = true;
    }
    this.isValidissueAndContractShortSale =
      this.hasShortSellContract && this.isIssueAllowedShortSell;
  }

  private _getChallenge() {
    this.setShowConfirmation(true);
  }

  /**
   * Update session when token is required
   */
  private updateSession(token: string) {
    this.patronService
      .upgradeToken(
        this.elPatronData.URL_UPGRADE_SESSION,
        this.readToken,
        token,
      )
      .pipe(
        catchError((error: Error) => {
          this.sendOperativeMessage('Token incorrecto', error.message);

          return observableEmpty();
        }),
      )
      .subscribe((value: any) => {
        this.registerOrder();
      });
  }

  private sendOperativeMessage(titleText: string, messageText: string) {
    let notificationMessage: any = {};

    notificationMessage = {
      message: messageText || 'Necesitas ingresar el token',
      title: titleText || 'Token Necesario',
    };
    this.notificationService.showWarning(notificationMessage);
  }
}
